import React from 'react';

// Canonical page back-link — the SINGLE source of truth for the "← …" nav button
// style used in page headers (and the feature-disabled gate cards). Change the style
// here to restyle every back button across all pages at once. Renders the arrow +
// a space, then the label (children), e.g. <BackLink href="/x">Dashboard</BackLink>.
const backLinkStyle = {
  padding: '8px 16px',
  borderRadius: 9,
  border: '1px solid var(--border)',
  background: 'transparent',
  color: 'var(--text)',
  fontSize: 13.5,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 7,
};

export default function BackLink({ href, children, style }) {
  return <a href={href} style={{ ...backLinkStyle, ...style }}>← {children}</a>;
}
